import React, { Component, Fragment } from "react"
import LazyLoadWrapper from "components/common/LazyLoadWrapper"

import HeroCover from "assets/images/cover.png"
// Import styles
import "../../css/components/common/cover.scss"
import "react-lazy-load-image-component/src/effects/blur.css"

class Cover extends Component {
  render() {
    const { data } = this.props

    return (
      <Fragment>
        <section className="landing-hero">
          <LazyLoadWrapper
            className="hero-image"
            src={data.cover || HeroCover}
            effect="blur"
            height="520px"
            width="100%"
          />
          <div className="text-container">
            <h1 className="name">{data.name}</h1>
            <p className="description">{data.description}</p>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default Cover
